import { type VendorConstructor } from '../../entities/Vendor'
import { type CreateVendorRequestResponse } from '../types/CreateVendorRequestResponse'

export const mapCreateVendorRequestResponseApiModel = (
  data: CreateVendorRequestResponse['data']
): VendorConstructor => ({
  id: data.id,
  externalId: data.vendor.external_id ?? '',
  name: data.vendor.name,
  active: false,
  address: {
    addressLineOne: data.vendor.address.address_line_one ?? '',
    addressLineTwo: data.vendor.address.address_line_two ?? '',
    postalCode: data.vendor.address.postal_code ?? '',
    city: data.vendor.address.city ?? '',
    stateProvince: data.vendor.address.state_province ?? '',
    country: data.vendor.address.country ?? '',
  },
  contactInfo: {
    phoneOne: data.vendor.phone_one ?? '',
    phoneTwo: data.vendor.phone_two ?? '',
    fax: data.vendor.fax ?? '',
    email: data.vendor.emails ?? [],
    contact: data.vendor.contact ?? '',
    url: data.vendor.url ?? '',
    emailConfigurations: null,
  },
  comments: data.vendor.comments ?? '',
  dateModified: data.updated_at ?? data.created_at ?? '',
  paymentTerm: data.vendor.payment_term_id
    ? {
        id: data.vendor.payment_term_id,
        name: '', // Payment term details not available in request response
        description: '',
        active: true,
      }
    : null,
  shippingTerm: data.vendor.shipping_term_id
    ? {
        id: data.vendor.shipping_term_id,
        name: '', // Shipping term details not available in request response
        description: '',
        active: true,
      }
    : null,
  shippingMethod: data.vendor.shipping_method_id
    ? {
        id: data.vendor.shipping_method_id,
        name: '', // Shipping method details not available in request response
        description: '',
        active: true,
      }
    : null,
  taxId: data.vendor.tax_id ?? null,
  legalName: null,
  taxIdMasked: null,
  taxIdType: null,
  taxIdTypeLabel: null,
  taxCountry: null,
  companyEmail: null,
  taxDocuments: [],
  taxIdProvided: false,
  taxDocumentUploaded: false,
  type: data.vendor.type,
  pdfLabelSet: data.vendor.po_pdf_labels ?? '',
  isAutoEmailPoEnabled: false, // Default value for new requests
  request: {
    id: data.id,
    name: data.vendor.name,
    requester: `${data.requester.first_name} ${data.requester.last_name}`,
    submittedDate: data.created_at ?? '',
    nextApproverName: `${data.next_approver.first_name} ${data.next_approver.last_name}`,
    permissions: {
      canApprove: false,
      canEdit: true,
      canDelete: true,
    },
  },
})
